/**
 * Created by alvinoktavianus on 5/9/17.
 */

import {
  ALL_OUTLETS,
  BILLINGS,
  CANCEL_SUBSCRIPTION,
  FEATURE_SUBSCRIPTION_PRICE,
  OUTLETS,
  RULES,
  SUBSCRIPTION_STATUS,
  VERIFY_BILLING
} from './constant'

export function getBillings (params) {
  return axios.get(BILLINGS, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function getOutlets (params) {
  return axios.get(OUTLETS, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function getRules (params) {
  return axios.get(RULES, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function getSubscriptionStatus (params) {
  return axios.post(SUBSCRIPTION_STATUS, null, {params, withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function verifyBilling (params) {
  return axios.post(VERIFY_BILLING, params, {withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      return Promise.reject(error.response)
    })
}

export function getFeatureSubscriptionPrice () {
  return axios.post(FEATURE_SUBSCRIPTION_PRICE, null, {withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function cancelSubscription (params) {
  return axios.put(CANCEL_SUBSCRIPTION, params, {withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}

export function getAllOutlets () {
  return axios.get(ALL_OUTLETS, {withCredentials: true})
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((error) => {
      let eobj
      if (error.response) {
        let data = error.response.data
        if (data.errors) {
          eobj = new Error(data.errors)
        } else if (data.message) {
          eobj = new Error(data.message)
        } else {
          eobj = new Error(error.message)
        }
      } else {
        eobj = new Error(error.message)
      }
      return Promise.reject(eobj)
    })
}



// WEBPACK FOOTER //
// ./app/api/billing/index.js